// extracted by mini-css-extract-plugin
export var dark = "styles-module--dark--3b6ab";
export var slider = "styles-module--slider--055f7";
export var transparent = "styles-module--transparent--f606d";
export var wrapper = "styles-module--wrapper--70d44";